import React from 'react'
import { TriangleAlert } from 'lucide-react'

// Renders advisory warnings about lesson-plan / tutoring-job fields that
// haven't been filled in yet. Used by the Job Ad confirm modal, the Request
// Search modal, and the Request Placement modal — all three flows benefit
// from sales reps seeing what's missing before proceeding.
//
// Returns null when nothing is missing.

class JobReadiness extends React.Component {

  render() {
    const lp = this.props.lesson_plan
    const tj = lp.tutoring_job
    const settings = tj.settings || {}
    const availability_times = (tj.availability && tj.availability.times) || []

    const missing = []

    if (!lp.enquiry_subject_ids || lp.enquiry_subject_ids.length === 0) {
      missing.push('Subjects')
    }
    if (!lp.medium) {
      missing.push('Lesson medium')
    }
    if (lp.medium === 'local' && (!lp.address || !lp.address.formatted_address)) {
      missing.push('Address')
    }
    if (!lp.learners_per_lesson || lp.learners_per_lesson < 1) {
      missing.push('Learners per lesson')
    }
    if (settings.budget == null || settings.budget === '') {
      missing.push('Budget')
    }
    if (!lp.tutor_gender) {
      missing.push('Tutor gender preference')
    }
    if (!tj.tutor_tier) {
      missing.push('Tutor tier')
    }
    if (!tj.language_id) {
      missing.push('Language')
    }
    if (!tj.curriculum) {
      missing.push('Curriculum')
    }
    if (!tj.commitment) {
      missing.push('Commitment')
    }
    if (!tj.start_date) {
      missing.push('Start date')
    }
    if (availability_times.length === 0) {
      missing.push('Client availability')
    }

    if (missing.length === 0) return null

    return (
      <div className="rounded-[10px] border border-[#f5d28c] bg-[#fff5e6] px-4 py-3">
        <div className="mb-2 flex items-center text-[13px] font-semibold text-[#92580f]">
          <TriangleAlert className="mr-2 size-4 text-[#d18d2c]"/>
          {missing.length} {missing.length === 1 ? 'field is' : 'fields are'} not set yet
        </div>
        <div className="flex flex-wrap gap-1.5">
          {missing.map((field) => (
            <span key={field} className="inline-block rounded-[14px] border border-[#f5d28c] bg-white px-2.5 py-[3px] text-xs text-[#92580f]">
              {field}
            </span>
          ))}
        </div>
        <div className="mt-2 text-xs text-[#92580f]">
          You can still proceed but it may lead to more back and forth as this information is shown to tutors.
        </div>
      </div>
    )
  }
}

export default JobReadiness
